import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("edupilot_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshInFlight = null;
async function tryRefresh() {
  if (refreshInFlight) return refreshInFlight;
  const rt = localStorage.getItem("edupilot_refresh");
  if (!rt) return null;
  refreshInFlight = axios.post(`${API_BASE}/auth/refresh`, { refresh_token: rt })
    .then((r) => {
      localStorage.setItem("edupilot_token", r.data.token);
      if (r.data.refresh_token) localStorage.setItem("edupilot_refresh", r.data.refresh_token);
      if (r.data.user) localStorage.setItem("edupilot_user", JSON.stringify(r.data.user));
      return r.data.token;
    })
    .catch(() => null)
    .finally(() => { refreshInFlight = null; });
  return refreshInFlight;
}

// Ağ/geçici hata retry (502/503/504/ECONNRESET/timeout)
const RETRY_STATUSES = new Set([502, 503, 504]);
const MAX_RETRIES = 2;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const status = err?.response?.status;
    // Auth refresh
    if (status === 401 && !orig._retried && !orig.url?.includes("/auth/")) {
      orig._retried = true;
      const t = await tryRefresh();
      if (t) {
        orig.headers = { ...(orig.headers || {}), Authorization: `Bearer ${t}` };
        return api(orig);
      }
    }
    // 502/503/504 veya network/timeout → exponential backoff retry (yalnız idempotent GET)
    const isNetwork = !err.response && err.code !== "ERR_CANCELED";
    const shouldRetry = (RETRY_STATUSES.has(status) || isNetwork) && (orig.method || "get").toLowerCase() === "get";
    if (shouldRetry) {
      orig._retryCount = (orig._retryCount || 0) + 1;
      if (orig._retryCount <= MAX_RETRIES) {
        const delay = 500 * Math.pow(2, orig._retryCount - 1); // 500ms → 1s
        await new Promise((res) => setTimeout(res, delay));
        return api(orig);
      }
    }
    // 401 (refresh başarısız) → giriş sayfasına
    if (status === 401) {
      localStorage.removeItem("edupilot_token");
      localStorage.removeItem("edupilot_refresh");
      localStorage.removeItem("edupilot_user");
      if (window.location.pathname !== "/giris" && window.location.pathname !== "/kayit" && window.location.pathname !== "/") {
        window.location.href = "/giris";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
